export { default } from "./dedicated"
export { default as DedicatedImage } from "./dedicated-image"
